<form>
  <mat-form-field class="content display-field" [floatLabel]="'always'">
    <mat-label>{{ label }}</mat-label>
    <input disabled matInput value="{{content}}">
    @if (isEditable) {
      <mat-icon class="table-icon" matSuffix matTooltip="EDIT Content" (click)="editIconClicked()">
        edit
      </mat-icon>
    }
  </mat-form-field>
</form>